import { DepositLimitFrequency } from '@mobi/api-types'
import { track, analyticsKeys } from '@mobi/account/Utils'

export type DepositLimitsEvent = {
  interaction_type: 'Set Deposit Limit'
  depositFrequency: DepositLimitFrequency | 'None' | undefined
  limitAmount: string | undefined
  location: undefined
}

const defaultAccountManagementValues: Omit<DepositLimitsEvent, 'interaction_type'> = {
  depositFrequency: undefined,
  limitAmount: undefined,
  location: undefined,
}

export const DepositLimitsTracker = (event: DepositLimitsEvent) =>
  track(analyticsKeys.accountManagement, event)

export const trackSetDepositLimit = (
  depositFrequency: DepositLimitFrequency,
  limitAmount: number
) =>
  DepositLimitsTracker({
    interaction_type: 'Set Deposit Limit',
    ...defaultAccountManagementValues,
    depositFrequency,
    limitAmount: limitAmount.toString(),
  })
